

const ms13 = {
  label: "Customer Group",
  pageLabel: "Customer Group",
  starting: true,
  url: "ms13",
  pageType: "history",
  form: [
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Code",
      label: "Code",
      name: "",
      description: "Enter Code"
    },
    {
      inputType: "numberonly",
      tab: "filter",
      isRequired:true,
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Code",
      label: "",
      name: "code",
      description: "Enter Code"
    },
    // {
    //   inputType: "displaytext",
    //   tab: "filter",
    //   widths: {
    //     parent: "col-sm-2",
    //     children: "col-sm-12"
    //   },
    //   placeHolder: "Code",
    //   label: "Code",
    //   name: "",
    //   description: "Enter Code"
    // },
    // {
    //   inputType: "fileupload",
      
    //   widths: {
    //     parent: "col-sm-6",
    //     children: "col-sm-12"
    //   },
    //   label: "Fileupload",
    //   name: "fileupload",
    //   // placeholder: {
    //   //   type: "text",
    //   //   value:
    //   //     "Try dropping some files here, or click to select files to upload."
    //   // },
    //   // files: [],
    // },
    // {
    //   inputType: "displaytext",
    //   tab: "filter",
    //   widths: {
    //     parent: "col-sm-2",
    //     children: "col-sm-12"
    //   },
    //   placeHolder: "Code",
    //   label: "Code",
    //   name: "",
    //   description: "Enter Code"
    // },
    // {
    //   inputType: "fileupload",
      
    //   widths: {
    //     parent: "col-sm-6",
    //     children: "col-sm-12"
    //   },
    //   label: "AdharCard",
    //   name: "AdharCard",
    //   // placeholder: {
    //   //   type: "text",
    //   //   value:
    //   //     "Try dropping some files here, or click to select files to upload."
    //   // },
    //   // files: [],
    // },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Description",
      label: "Description",
      name: "",
      description: "Enter Description"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Description",
      label: "",
      name: "description",
      description: "Enter Description"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Description(Regional)",
      label: "Description(Regional)",
      name: "",
      description: "Enter Description(Regional)"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Description(Regional)",
      label: "",
      name: "descriptionRegional",
      description: "Enter Description(Regional)"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: true,
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Active",
      label: "Active",
      name: "active",
      description: "Active"
    }
  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Code",
        accessor: "LoginName",
        width: 150
      },
      {
        Header: "Description",
        accessor: "lastname",
        width: 150
      },
      {
        Header: "Account No.",
        accessor: "email"
      }
    ]
  }
};

export default ms13;
